<template>
    <div id="ContainerPatient">
      <div class="row">
          <div class="col-12">
            <MdTitle v-bind:Text="$t('ClaimBatchStatus.ReviewClaimStatus')"/>
          </div>
      </div>
                            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                                <div class="input-group" dir="ltr">
                                    <input
                                    type="text"
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"
                                    @keyup.enter="searchListing()"
                                    >
                                    <div class="input-group-append">
                                        <MdButton
                                        v-bind:Name="'btnsearchinput'"
                                        v-bind:VariantProp="'btn btn-sm search-attached'"
                                        v-bind:IconClass="'mdi mdi-magnify'"
                                        >
                                        </MdButton>
                                    </div>
                                </div>
                            </div>

      <b-row>
            <b-col md="3" lg="3" sm="12">
								<!--<MdEdit
									v-bind:Label="$t('Shared.datefrom')"
									v-bind:TypeProp="'date'"
									v-bind:Name="'DateFrom'"
									v-model="DateFrom"
									v-bind:Min="'1900-01-01'"
									v-bind:Max="'2200-12-31'"
									v-on:change="DateFromChange($event)"
									v-bind:Id="'input_date_from'"
									v-bind:OnPressEnter="getClaimList">
              </MdEdit>-->
              <MdDateTime
                :Label="$t('Shared.datefrom')"
                :Model="DateFrom"
                @input="DateFrom = $event"
                :Id="'ClaimBatchStatusListDateFrom'"
                :Type="'date'"
                :isRequired="false"
                :Change="DateFromChange"
                :OnPressEnter="getClaimList"
                :isConfirm="false"
                :ReadOnly="false">
            </MdDateTime>
						</b-col>
						<b-col md="3" lg="3" sm="12">
										<!--<MdEdit
											v-bind:Label="$t('Shared.dateTo')"
											v-bind:TypeProp="'date'"
											v-bind:Name="'DateTo'"
											v-model="DateTo"
											v-bind:Min="'1900-01-01'"
											v-bind:Max="'2200-12-31'"
											v-on:change="DateToChange($event)"
											v-bind:Id="'input_date_to'"
											v-bind:OnPressEnter="getClaimList">
										</MdEdit>-->
                    <MdDateTime
                      :Label="$t('Shared.dateTo')"
                      :Model="DateTo"
                      @input="DateTo = $event"
                      :Id="'ClaimBatchStatusListDateTo'"
                      :Type="'date'"
                      :isRequired="false"
                      :Change="DateToChange"
                      :OnPressEnter="getClaimList"
                      :isConfirm="false"
                      :ReadOnly="false">
                  </MdDateTime>
						</b-col>
            <b-col lg="3" md="3" sm="12">
               <!-- <MdLookup
                     v-bind:ModelCode="BatchNo"
                     v-bind:ModelDescription="BatchNoDescription"
                     v-bind:Label="$t('ItemExpFiltersRep.BatchNo')"
                     v-bind:RefCode="'BatchNo'"
                     v-bind:Api="'ClaimStatuses/BatchNo'"
                     v-bind:FieldCode="'code'"
                     v-bind:FieldDescription="'description'"
                     :SearchTitle="$t('Batch No')"
                     :GetValues="onCodeConditionOk"
                     :SearchFieldCode="'Code'"
                  /> -->
                <MdLookupMultiSelect
                        v-bind:Label="$tc('ItemExpFiltersRep.BatchNo')"
                        v-bind:ModelCode="batchNoCodeModel"
                        v-bind:RefCode="'batchno'"
                        v-bind:Api="'ClaimStatuses/BatchNo'"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'description'"
                        :SearchTitle="$tc('Batch No')"
                        :GetValues="getBatchNoValues"
                        :InvalidFeedback="$t('Msg.InvalidCode')"
                        :SearchFieldCode="'Code'"
                        :ServerSidePagination="true"
                        v-bind:Fields="batchNoLookupFields"
                    />
            </b-col>
            <b-col lg="3" md="3" sm="12">
               <!-- <MdLookup
                     v-bind:ModelCode="CheckNo"
                     v-bind:ModelDescription="CheckNoDescription"
                     v-bind:Label="$t('ClaimBatchStatus.CheckNo')"
                     v-bind:RefCode="'CheckNo'"
                     v-bind:Api="'ClaimStatuses/CheckNo'"
                     v-bind:FieldCode="'code'"
                     v-bind:FieldDescription="'description'"
                     :SearchTitle="$t('Check No')"
                     :GetValues="onCodeConditionOk"
                     :SearchFieldCode="'Code'"
                  /> -->
                <MdLookupMultiSelect
                        v-bind:Label="$tc('ClaimBatchStatus.CheckNo')"
                        v-bind:ModelCode="checkNoCodeModel"
                        v-bind:RefCode="'checkno'"
                        v-bind:Api="'ClaimStatuses/CheckNo'"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'description'"
                        :SearchTitle="$tc('Check No')"
                        :GetValues="getCheckNoValues"
                        :InvalidFeedback="$t('Msg.InvalidCode')"
                        :SearchFieldCode="'Code'"
                        :ServerSidePagination="true"
                        v-bind:Fields="checkNoLookupFields"
                    />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('ClaimBatchStatus.ClaimStatus')"
              v-bind:Options="StatusList"
              v-bind:Model="Status"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Multiple="false"
              :Input="ChangeDropdownStatus"
              />
            </b-col>
            <b-col lg="3" md="3" sm="12">
              <MdSelect
                v-bind:Label="$t('Shared.PatientInsurance')"
                v-bind:Options="InsuranceList"
                v-bind:Model="InsuranceModelList"
                v-bind:FieldDescription="'company'"
                v-bind:FieldCode="'insurancecode'"
                v-bind:Multiple="true"
                :Input="ChangeDropdownInsurance"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.Provider')"
              v-bind:Options="ProviderList"
              v-bind:Model="ProviderModelList"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Multiple="true"
              :Input="ChangeDropdownProvider"
              />
            </b-col>
           <b-col lg="3" md="3" sm="12">
              <MdSelect
                v-bind:Label="$t('ClaimBatchStatus.PaidPrimary')"
                v-bind:Options="OptionList"
                v-bind:Model="PaidPrimary"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'value'"
                v-bind:Multiple="false"
                :Input="ChangeDropdownPrimary"/>
            </b-col>
          </b-row>

          <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                    v-bind:Label="$t('ClaimBatchStatus.PaidSecondary')"
                    v-bind:Options="OptionList"
                    v-bind:Model="PaidSecondary"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"

                    :Input="ChangeDropdownSecondary"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                    v-bind:Label="$t('ClaimBatchStatus.PaidPatient')"
                    v-bind:Options="OptionList"
                    v-bind:Model="PaidPatient"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"

                    :Input="ChangeDropdownPaidPatient"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                    v-bind:Label="$t('PatientClaimList.Denied')"
                    v-bind:Options="OptionList"
                    v-bind:Model="Denied"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"

                    :Input="ChangeDropdownDenied"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                    v-bind:Label="$t('ClaimBatchStatus.FileCreated')"
                    v-bind:Options="OptionList"
                    v-bind:Model="FileCreated"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"

                    :Input="ChangeDropdownFileCreated"
                    />
                </b-col>
          </b-row>
          <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                    v-bind:Label="$t('ClaimBatchStatus.Transmitted')"
                    v-bind:Options="OptionList"
                    v-bind:Model="Transmitted"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"

                    :Input="ChangeDropdownTransmitted"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                    v-bind:Label="$t('ClaimBatchStatus.Errors')"
                    v-bind:Options="OptionList"
                    v-bind:Model="Errors"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    :Input="ChangeDropdownErrors"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                    v-bind:Label="$t('ClaimBatchStatus.ARStatus')"
                    v-bind:Options="ARStatusList"
                    v-bind:Model="ARStatusModelList"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Multiple="true"
                    :Input="ChangeDropdownARStatus"
                    />
                </b-col>


                <b-col lg="3" md="3" sm="12">
                    <MdLookupMultiSelect
                        v-bind:Label="$tc('Shared.Patient', 2)"
                        v-bind:ModelCode="patientCodeModel"
                        v-bind:RefCode="'patientcode'"
                        v-bind:Api="'Patients'"
                        v-bind:FieldCode="'patientcode'"
                        v-bind:FieldDescription="'firstname'"
                        :SearchTitle="$tc('Shared.Patient', 2)"
                        :GetValues="getPatientValues"
                        :InvalidFeedback="$t('Msg.InvalidCode')"
                        :SearchFieldCode="'PatientCode'"
                        :AuxFields="patientAuxFields"
                        :FieldsDate="patientFieldsDate"
                        :ServerSidePagination="true"
                        v-bind:Fields="patientLookupFields"
                    />
                </b-col>
            </b-row>

                        <b-row>
                <b-col cols="12" class="text-right">
                    <button
                    type="button"
                    v-on:click="searchListing"
                    class="btn btn-primary btn-login mt-2"
                    id="btnsearchinput"
                    >
                    {{ $t('Shared.Search') }}
                    </button>
                </b-col>
                </b-row>

           <!--  <b-row>
                  <b-col md="12">
										<div class="text-center text-md-right mt-3">
											<button
												type="button"
                        v-on:click="searchListing"
												class="btn btn-primary btn-login mx-2 pull-right"
												id="btnsearchinput">
												{{ $t('Shared.Search') }}
											</button>
										</div>
									</b-col>
        </b-row>-->
        <div class="row">
          <div class="col-12">
              <div>
                <MdTitle v-bind:Text="ViewText" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                        <div class="col-12 mb-3">
                          <div class="row" style="font-weight:500;">
                            <b-col lg="2" md="2" sm="2">
                              <p>Charges: {{ Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(charges) }}</p>
                            </b-col>
                            <b-col lg="2" md="2" sm="2">
                              <p>Payments: {{ Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(payments) }}</p>
                            </b-col>
                            <b-col lg="2" md="2" sm="2">
                              <p>Adjustments: {{ Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(adjustments) }}</p>
                            </b-col>
                            <b-col lg="2" md="2" sm="2">
                              <p>Denied: {{ Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(denied) }}</p>
                            </b-col>
                            <b-col lg="2" md="2" sm="2">
                              <p>Balance: {{ Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(balance) }}</p>
                            </b-col>
                            <b-col lg="2" md="2" sm="2">
                              <p>Count: {{ count }}</p>
                            </b-col>
                          </div>
                        </div>

                          <MdTable
                          v-bind:fields="fields"
                          v-bind:items="items"
                          v-bind:totalRows="totalRows"
                          v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                          v-bind:currentPage="currentPage"
                          v-bind:perPage="perPage"
                          v-bind:pageOptions="pageOptions"
                          v-bind:refTable="'claimStatusTable'"
                          :onRowSelected="onRowSelected"
                          v-bind:IsClaimBatchStatus="true"
                          :ClaimStatusDown="StatusIcon"
                          :ClaimStatusError="ErrorIcon"
                          :viewIconEvent="ViewIcon"
                          :ClaimStatusEditNote="EditIcon"
                          :ClaimStatusEditARStatus="AddStatus"
                          :pageChanged="pageChanged"
                          :multiSelect="true"
                          :perPageFunction="PerPageFunction">
                          </MdTable>

                          <!--<div class="space-actions"></div>
                            <div class="page-actions">
                              <button
                                  v-on:click="validateClaimList"
                                  type="button"
                                  class="btn btn-primary btn-login mx-2 pull-right"
                                  id="btnsearchinput">
                                  Validate
                              </button>
                            </div>-->

              </div>

               <ClaimBatchStatusModal v-if="showModalClaimError"
                  v-bind:TitleWindow="$t('ClaimBatchStatus.modalError')"
                  v-bind:items="errorList"
                  @getCodeConditionOK="OnReturnError($event)"
                  @getCodeConditionCANCEL="OnReturnErrorCancel($event)"
                  v-bind:ModalId="modalIdError">
              </ClaimBatchStatusModal>

              <ClaimNotesModal v-if="showModalClaimNotes"
                  v-bind:TitleWindow="$t('Claim Notes for Seq No:') + ' ' + ClaimNotesHistoryParameter.SeqNo"
                  v-bind:items="notesList"
                  v-bind:arStatusItems="arStatusList"
                  @getCodeConditionOK="OnReturnNotes($event)"
                  @getCodeConditionCANCEL="OnReturnNotesCancel($event)"
                  v-bind:SeqNo="ClaimNotesHistoryParameter.SeqNo"
                  @refreshNotes="handleRefreshNotes"
                  v-bind:ModalId="modalIdNotes">
              </ClaimNotesModal>

              <ClaimARStatusModalEdit v-if="showModalClaimARStatus"
                  v-bind:TitleWindow="$t('Add AR Status')"
                  v-bind:ARStatusItems="selected"
                  @confirmAddStatus="OnReturnARStatus($event)"
                  @cancelAddStatus="OnReturnARStatusCancel($event)"
                  v-bind:ARStatusList="ARStatusEditList"
                  v-bind:ModalId="modalIdARStatus">
              </ClaimARStatusModalEdit>

              <ClaimNoteModalEdit v-if="showClaimNoteModalEdit"
                v-bind:ModalId="'modalClaimNoteEdit'"
                v-bind:TitleWindow="ModalTitle"
                v-bind:NoteItems="selected"
                v-bind:ModelNote="ModelNote"
                v-bind:IsReadOnly="IsReadOnly"
                @getViewOk="closeClaimNoteModalEdit"/>
          </div>

        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
            <b-dropdown
                id="dropdown-dropup"
                dropup
                :text="$tc('Shared.ActionsTxt', 2)"
                variant="primary"
                class="m-2"
            >
                <b-dropdown-item href="#" v-if="addBulkStatus" v-on:click="ChangeBulkStatus()">
                    {{ $t('Change Status') }}
                </b-dropdown-item>
                <b-dropdown-item href="#" v-if="addBulkNotes" v-on:click="AddBulkNotes()">
                    {{ $t('Add Notes') }}
                </b-dropdown-item>
            </b-dropdown>
        </div>
    </div>

</template>

<script>
import ClaimList from '@/services/claimlist.service';
import ClaimHistory from '@/services/claimhistory.service';
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import GlobalService from '@/services/global.service'
import Utils from "@/common/utils";
import moment from "moment";
//import ClaimBatch from '@/services/claimbatch.service';

export default {
        mixins: [ShowMessage, DBFunctions],
        name: 'ClaimBatchStatus',
        data() {
          return {

            errorList:[],
            notesList:[],
            arStatusList:[],
            patientCodeModel: [],
            patientAuxFields: ['lastname'],
            patientFieldsDate: ['dob'],
            patientLookupFields: [
                { key: 'firstname', sortable: true, label: this.$t('Shared.FirstName') },
                { key: 'lastname', sortable: true, label: this.$t('Shared.LastName') },
                { key: 'patientcode', sortable: true, label: this.$t('Shared.Code') },
                { key: 'dob', sortable: true, label: this.$t('Shared.Dob') }
            ],
            batchNoCodeModel: [],
            batchNoLookupFields: [
                { key: 'code', sortable: true, label: this.$t('Shared.Code') },
                { key: 'description', sortable: true, label: this.$t('Shared.Description') }
            ],
            checkNoCodeModel: [],
            checkNoLookupFields: [
                { key: 'code', sortable: true, label: this.$t('Shared.Code') },
                { key: 'description', sortable: true, label: this.$t('Shared.Description') }
            ],
            InsuranceModelList: [],
            ProviderModelList: [],
            showModalClaimARStatus:false,
            showModalClaimError:false,
            showModalClaimNotes:false,
            ViewText:this.$t('Shared.SearchResult'),
            Loading:true,
            ShowMessageIsEmpty:false,
            modalIdError:"modalIdErrorClaimBatchStatus",
            modalIdNotes:"modalIdNotesClaimBatchStatus",
            modalIdARStatus:"modalIdARStatusClaimBatchStatus",
            status:{
              selected:true,
              value:true,
              text:this.$t('Shared.Active')
            },
            BatchNo: "",
            CheckNo: "",
            Status: {code:"",description:""},
            InsuranceCode: {insurancecode:"",company:""},
            Provider: {code:"",name:""},
            ARStatus: {code:"",description:""},
            BatchNoDescription:"",
            CheckNoDescription:"",



            PaidPrimary: {name:"All",value:0},
            PaidSecondary: {name:"All",value:0},
            PaidPatient: {name:"All",value:0},
            Denied: {name:"All",value:0},
            FileCreated: {name:"All",value:0},
            Transmitted: {name:"All",value:0},
            Errors: {name:"All",value:0},
            DateFrom: '',
            DateTo: '',

            parameter:{
              SearchCriteria:'',
              PageNumber : 0,
              PageSize:0,
              BatchNoList: [],
              CheckNoList: [],
              Status: '',
              InsuranceList: [],
              Provider: '',
              PaidPrimary: 0,
              PaidSecondary: 0,
              PaidPatient: 0,
              Denied: 0,
              Created: 0,
              Transmitted: 0,
              Errors: 0,
              DateFrom: '',
              DateTo: '',
              ARStatusList: [],
              PatientCodeList:[],
            },
            ClaimNotesHistoryParameter: {
              SearchCriteria: '',
              PageNumber: 0,
              PageSize: 0,
              SeqNo: 0
            },
            OptionsRightMenu:{
              visible:false,
              ItemsList:[],
              btnvisible:false,
              itemdisabled: false,
              PatientCode:'',
              Mode:this.edit_mode,
              favButtonAtion:false
            },

            fields: [
           //   { key: 'error', sortable: true, label: this.$t('Error'), class: 'text-rigth' },
              { key: 'status', sortable: true, label: this.$t('Create Date/Claim Status'), class: 'text-rigth' },
              { key: 'arStatus', sortable: true, label: this.$t('AR Status'), class: 'text-rigth' },
              { key: 'patientName', sortable: true, label: this.$t('Patient Name'), class: 'text-rigth' },
              { key: 'patientCode', sortable: true, label: this.$t('Patient Code'), class: 'text-rigth' },
              { key: 'clMUID', sortable: true, label: '', class: 'text-rigth hidden' },
              { key: 'batchId', sortable: true, label: '', class: 'text-rigth hidden' },
              //{ key: 'createDate', sortable: true, label: this.$t('Create Date'), class: 'text-rigth' },
              { key: 'dateFrom', sortable: true, label: this.$t('Date From'), class: 'text-rigth' },
              { key: 'dateTo', sortable: true, label: this.$t('Date To'), class: 'text-rigth',},
              { key: 'seqNo', sortable: true, label: this.$t('ClaimBatchStatus.seqNo'), class: 'text-rigth' },
              { key: 'issLineNo', sortable: true, label: this.$t('Shared.LineNo'), class: 'text-rigth' },
              { key: 'insuranceCode', sortable: true, label: this.$t('Insurance'), class: 'text-rigth' },
              { key: 'primInsuranceName', sortable: true, label: this.$t('ClaimBatchStatus.primInsuranceName'), class: 'text-rigth' },
              { key: 'primInsuranceNo', sortable: true, label: this.$t('Shared.PrimInsuranceNo'), class: 'text-rigth' },
              { key: 'cpT_HCPCS', sortable: true, label: this.$t('CPT/REV'), class: 'text-rigth' },
              { key: 'hcpcscode', sortable: true, label: this.$t('HCPCS'), class: 'text-rigth' },
              { key: 'modifieR_1', sortable: true, label: this.$t('M1'), class: 'text-rigth' },
              { key: 'modifieR_2', sortable: true, label: this.$t('M2'), class: 'text-rigth' },
              { key: 'day_Unit', sortable: true, label: this.$t('Day/Unit'), class: 'text-rigth' },
              { key: 'charges', sortable: true, label: this.$t('Charges'), class: 'text-rigth', formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'balance', sortable: true, label: this.$t('Balance'), class: 'text-rigth', formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'primPayment', sortable: true, label: this.$t('ClaimBatchStatus.primPayment'), class: 'text-rigth', formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'primAdjAMT', sortable: true, label: this.$t('ClaimBatchStatus.primAdjAMT'), class: 'text-rigth', formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'primDeniedAMT', sortable: true, label: this.$t('ClaimBatchStatus.primDeniedAMT'), class: 'text-rigth', formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'payDate', sortable: true, label: this.$t('ClaimBatchStatus.payDate'), class: 'text-rigth' },
              //{ key: 'payRef', sortable: true, label: this.$t('Shared.PayReference'), class: 'text-rigth' },

              { key: 'secPayment', sortable: true, label: this.$t('ClaimBatchStatus.secPayment'), class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'secAdjAMT', sortable: true, label: this.$t('ClaimBatchStatus.secAdjAMT'), class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'secDeniedAMT', sortable: true, label: this.$t('ClaimBatchStatus.secDeniedAMT'), class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'terPayment', sortable: true, label: this.$t('ClaimBatchStatus.terPayment'), class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'terAdjAMT', sortable: true, label: this.$t('ClaimBatchStatus.terAdjAMT'), class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'terDeniedAMT', sortable: true, label: this.$t('ClaimBatchStatus.terDeniedAMT'), class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'patientPayment', sortable: true, label: this.$t('ClaimBatchStatus.patientPayment'), class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'patientAdjAMT', sortable: true, label: this.$t('ClaimBatchStatus.patientAdjAMT'), class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'patientDeniedAMT', sortable: true, label: this.$t('ClaimBatchStatus.patientDeniedAMT'), class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },
              { key: 'credit', sortable: true, label: this.$t('Shared.Credit'), class: 'text-rigth',formatter: value => {return Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(value)} },

              { key: 'doctorName', sortable: true, label: this.$t('Provider'), class: 'text-rigth' }
              ],
            OptionList: [
                    {name:"All",value:0},
                    {name:"Yes",value:1},
                    {name:"No", value:2}
            ],
            pageOptions: [5,10,20,30,40,50],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            currentPageNotes: 1,
            perPageNotes: 10,
            currentPageStatus: 1,
            perPageStatus: 10,
            filter: null,
            filterOn: [],
            items: [],
            errorItems: [],
            errors: [],
            selected: [],
            Header:{},
            isReadOnly: false,
            refTable: 'selectableTable',
            isVisible: false,
            BatchNoList: [],
            CheckNoList: [],
            StatusList: [],
            InsuranceList: [],
            ProviderList: [],
            charges: '',
            payments: '',
            adjustments: '',
            denied: '',
            balance: '',
            count: '',
            errorClaims: [],
            validationError: '',
            validationClaimId: '',
            validationStatus: '',
            checkClaimError: false,
            dateFrom: '',
            dateTo: '',
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            ARStatusList: [],
            ARStatusModelList: [],
            ARStatusEditList: [],
            selectedRow: {},
            addBulkStatus: false,
            addBulkNotes: false,
            showClaimNoteModalEdit: false,
            ModelNote: '',
            iconStatus: 'med-plus',
          }
        },

        methods: {

          // onCodeConditionOk(result){
          //     var type = result.FieldName;
          //   if(type.indexOf('BatchNo') >= 0) {
          //    switch (type) {
          //      default:
          //       this.BatchNo = result.code;
          //       this.BatchNoDescription = result.description;
          //       this.getClaimList();
          //    }
          //   }
          //   else if(type.indexOf('CheckNo') >= 0){
          //       this.CheckNo = result.code;
          //       this.CheckNoDescription = result.description;
          //       this.getClaimList();
          //   }
          // },

          getBatchNoValues(values){
            this.batchNoCodeModel = values;
            this.parameter.BatchNoList = values || [];
            //this.getClaimList();
          },

          getCheckNoValues(values){
            this.checkNoCodeModel = values;
            this.parameter.CheckNoList = values || [];
            //this.getClaimList();
          },

          getPatientValues(values){
            this.patientCodeModel = values;
            this.parameter.PatientCodeList = values || [];
            //this.getClaimList();
          },

          OnReturnError(){
            this.showModalClaimError = false;
          },

          OnReturnErrorCancel(){
            this.showModalClaimError = false;
          },

          OnReturnNotes(){
            this.showModalClaimNotes = false;
          },

          OnReturnNotesCancel(){
            this.showModalClaimNotes = false;
          },

          OnReturnARStatus(){
            this.showModalClaimARStatus = false;
            this.selected = [];
            this.getClaimList();
            this.getClaimListTotal();
          },

          OnReturnARStatusCancel(){
            this.showModalClaimARStatus = false;
            this.selected = [];
          },

          closeClaimNoteModalEdit() {
            this.showClaimNoteModalEdit = false;
            this.selected = [];
          },

          ChangeDropdownBatchNo(item) {
            this.parameter.BatchNo = item ? item.code : "";
            this.currentPage = 1;
            //this.getClaimList();
          },

          ChangeDropdownCheckNo(item) {
            this.parameter.CheckNo = item ? item.code : "";
            this.currentPage = 1;
            //this.getClaimList();
          },

          ChangeDropdownStatus(item) {
            this.parameter.Status = item ? item.code : "";
            this.currentPage = 1;
            //this.getClaimList();
          },

          ChangeDropdownInsurance(items) {
            this.InsuranceModelList = items || [];
            var insurances = []
            this.InsuranceModelList.forEach((item) => {
              insurances.push(item.insurancecode);
            });
            this.parameter.InsuranceList = insurances;
            this.currentPage = 1;
            //this.getClaimList();
          },

          ChangeDropdownProvider(items) {
            this.ProviderModelList = items || [];
            var providers = []
            this.ProviderModelList.forEach((item) => {
              providers.push(item.code);
            });
            this.parameter.ProviderList = providers;
            this.currentPage = 1;
            //this.getClaimList();
          },

          ChangeDropdownPrimary(item) {
            this.parameter.PaidPrimary = item ? item.value : 0;
            this.currentPage = 1;
            //this.getClaimList();
          },

          ChangeDropdownSecondary(item) {
            this.parameter.PaidSecondary = item ? item.value : 0;
            this.currentPage = 1;
            //this.getClaimList();
          },

          ChangeDropdownPaidPatient(item) {
            this.parameter.PaidPatient = item ? item.value : 0;
            this.currentPage = 1;
            //this.getClaimList();
          },

          ChangeDropdownDenied(item) {
            this.parameter.Denied = item ? item.value : 0;
            this.currentPage = 1;
            //this.getClaimList();
          },

          ChangeDropdownFileCreated(item) {
            this.parameter.Created = item ? item.value : 0;
            this.currentPage = 1;
            //this.getClaimList();
          },

          ChangeDropdownTransmitted(item) {
            this.parameter.Transmitted = item ? item.value : 0;
            this.currentPage = 1;
            //this.getClaimList();
          },

          ChangeDropdownErrors(item) {
            this.parameter.Errors = item ? item.value : 0;
            this.currentPage = 1;
            //this.getClaimList();
          },

          ChangeDropdownARStatus(items) {
            this.ARStatusModelList = items || [];
            var arstatuses = []
            this.ARStatusModelList.forEach((item) => {
              arstatuses.push(item.code);
            });
            this.parameter.ARStatusList = arstatuses;
            this.currentPage = 1;
            //this.getClaimList();
          },

          StatusIcon(row){
            this.ValidateandGetStatus(row);
          },

          ErrorIcon(row){
            this.getCLaimsError(row);
          },

          async ViewIcon(row) {
            this.selectedRow = row;
            this.$emit("load", true);
            await Promise.all([
                this.getClaimNotesHistory(row),
                this.getClaimARStatusHistory(row)
            ]);
            this.showModalClaimNotes = true;
            this.$emit("load", false);
          },

          EditIcon(row){
            this.selected.push(row);
            this.showClaimNoteModalEdit = true;
            this.ModelNote = '';
            this.IsReadOnly = false;
            this.ModalTitle = this.$t('Add Notes');
          },

          AddStatus(row){
            this.selected.push(row);
            this.showModalClaimARStatus = true;
          },

          DateFromChange(){

          },

          DateToChange(){

          },


          onRowSelected(item) {
            this.selected = item
            console.log(this.selected)
            if(this.selected && this.selected.length > 0) {
              this.addBulkStatus = true;
              this.addBulkNotes = true;
            }
          },

          searchListing() {
            this.currentPage = 1;
            this.getClaimList();
          },

          pageChanged (page) {
            this.currentPage = page;
            this.getClaimList();
          },

          PerPageFunction(perpage){
            this.perPage = perpage;
            this.currentPage = 1;
            this.getClaimList();
          },


    getStatus(){
        ClaimList.getStatus()
            .then((response) => {
              if(response.status == '200' && response.data){
                this.StatusList = response.data;
              }
            })
            .catch((error) => {
              if (error.response) {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
    },

    getARStatus() {
      ClaimList.getClaimRcmStatus()
        .then((response) => {
          if (response.status == '200' && response.data) {
            this.ARStatusEditList = response.data;
            response.data.forEach((item) => {
              item.description = item.code + " - " + item.description;
              this.ARStatusList.push(item);
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            this.showMessage(this.$tc('Msg.Error'), error, "error");
          }
        });
    },

    getInsurances(){
        ClaimList.getInsurances()
            .then((response) => {
              if(response.status == '200' && response.data){
                this.InsuranceList = response.data;
              }
            })
            .catch((error) => {
              if (error.response) {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
    },

    getProviders(){
        ClaimList.getProviders()
            .then((response) => {
              if(response.status == '200' && response.data){
                this.ProviderList = response.data;
              }
            })
            .catch((error) => {
              if (error.response) {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
    },


    async getDateTime() {
       await GlobalService.getDateTime()
            .then((response) => {
               if (response.data) {
                this.DateFrom = moment(response.data).subtract(7,'d').format('YYYY-MM-DD');
                this.DateTo = Utils.formatterDate(response.data);
               }
         })
         .catch(error => {
            if (error.response) {
               this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
         });
      },


      UpdateError(arr,item){
        arr.forEach(element => {
          if(element.clMUID === item.clmuid){
            element.hasErrors = item.hasErrors;
          }
        });
      },


      /*UpdateStatus(obj){
        let arr = this.items;




        arr.forEach(element => {
          if(element.batchNo === obj.status.batchNo){
            element.status = obj.status.status;
          }
        });

        for(var i = 0; i < obj.claims.length; i++){
          this.UpdateError(arr,obj.claims[i]);
        }
         this.isUpdateTable = false;
         this.items = arr;
      },*/


      ValidateandGetStatus(item) {
        this.$emit("load", true);
        ClaimList.ValidateAndGetStatus(item.batchId)
            .then((response) => {
               if (response.status == '200') {
                this.getClaimList();
               }

              this.$emit("load", false);
         })
         .catch(error => {
           //this.UpdateStatus(data);
           this.$emit("load", false);
            if (error.response) {
               this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
         });
      },

       getCLaimsError(item) {
        this.$emit("load", true);
        ClaimList.getClaimError(item.clMUID)
            .then((response) => {
               if (response.data) {
               let data = response.data;
              /* let obj = {
                  clmuid: "5111-001",
                  errors: "",
                  errorObjects: [
                  {
                    "name": "Payer Not Matched",
                    "message": "The claim payer must be match to a system payer"
                  },
                  {
                    "name": "Invalid Insurance Adjudication Information",
                    "message": "IF     Payer Sequence Number is greater than or equal to Destination Insurance Number THEN     Prior Payment Amount must be equal 0.00 AND The Insurance Line Adjustments must NOT be entered AND The Insurance Payment Date must NOT be entered"
                  }
                ],
              severity: "ERROR",
              recID: 2
              }

              this.errorList = obj.errorObjects;*/
               this.errorList = data.errorObjects;
                this.showModalClaimError = true;
                 console.log(data);
               }
                this.$emit("load", false);
         })
         .catch(error => {
           this.$emit("load", false);
            if (error.response) {
               this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
         });
      },




         /* HasOneParameter(arr){
            let count = 0;
            arr.forEach(element => {
              element.visibleActionClaimStatus = false;
             if(element.canDownload || element.hasErrors){
                count+=1;
                element.visibleActionClaimStatus = true;
             }
            });
            this.VisibleAction = count > 0 ? true : false;
            this.isUpdateTable = false;
            return count > 0;
          },*/


         /* StopLoadandUpdateDom(){
            this.isUpdateTable = true
            this.$emit('load', false);
          },*/

          async getClaimList() {
            this.errorItems = []
            this.parameter.DateFrom = this.DateFrom;
            this.parameter.DateTo = this.DateTo;
            this.parameter.PageSize = this.perPage;
            this.parameter.PageNumber = this.currentPage;
            this.parameter.BatchNo = this.BatchNo;
            this.parameter.CheckNo = this.CheckNo;
            this.$emit("load", true)
            if(new Date(this.DateFrom) > new Date(this.DateTo)){
              this.$emit('load', false);
              this.showMessage(this.$tc('Msg.Error'),this.$t('Invalid date range'),"error");
              return;
            }
            await ClaimList.listing(this.parameter).then((response) => {
              this.items = response.data;
             //let count = 0;
              this.items.forEach(element => {
               // element.canDownload = count % 2 !== 0 ? true :false;
               // element.hasErrors = count % 2 !== 0 ? true :false;
              //  element.batchNo = "422682504303411975095";
               // element.clMUID = "4980-001"
                element.dateFrom = element.dateFrom ? Utils.formatterDateToString(element.dateFrom) : null;
                element.dateTo =  element.dateTo ? Utils.formatterDateToString(element.dateTo) : null;
                element.createDate = element.createDate ? Utils.formatterDateToString(element.createDate) : null;
                element.payDate = element.payDate ? Utils.formatterDateToString(element.payDate) : null;
                element.balance = element.charges - (element.primAdjAMT + element.primPayment + element.secPayment + element.terPayment + element.patientPayment);
                //count++;
              })


              if(response.status == '200' && response.data && response.data.length > 0){
                let headerString = response.headers["x-pagination"];
                this.Header = JSON.parse(headerString);
                this.totalRows = this.Header.TotalCount;
              }




              if(this.items.length === 0){
                this.ShowMessageIsEmpty = true;
              }
              this.$emit('load', false);
              this.getClaimListTotal()
            }).catch(error => {
              this.$emit('load', false);
              if (!error.response) {
                  // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
                })
          },

          async getClaimListTotal() {
            this.$emit("load", true)
            this.parameter.DateFrom = this.DateFrom;
            this.parameter.DateTo = this.DateTo;
            this.parameter.PageSize = this.perPage;
            this.parameter.PageNumber = this.currentPage;
            this.parameter.BatchNo = this.BatchNo;
            this.parameter.CheckNo = this.CheckNo;
            this.$emit("load", true);
            await ClaimList.totalListing(this.parameter).then((response) => {

              this.charges = response.data[0].charges;
              this.balance = response.data[0].balance;
              this.adjustments = response.data[0].adjamt;
              this.denied = response.data[0].deniedAmt;
              this.count = response.data[0].numbers;
              this.payments = response.data[0].payment;
              // this.ViewText = this.$t('Shared.SearchResult') +
              // " - Charges: "+Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(this.charges)+
              // " - Payments: "+Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(this.payments)+
              // " - Adjustments: "+Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(this.adjustments)+
              // " - Denied: "+Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(this.denied)+
              // " - Balance: "+Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(this.balance)+
              // " - Count: "+Intl.NumberFormat(Utils.getLocale(), { style: "currency", currency: "USD" }).format(this.count);

            this.$emit("load", false)
            }).catch(error => {
              this.$emit('load', false);
              if (!error.response) {
                  // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
                })
          },

          handleRefreshNotes(){
              this.getClaimNotesHistory(this.selectedRow);
          },

          async getClaimNotesHistory(item) {
            this.ClaimNotesHistoryParameter.SeqNo = item.seqNo;
            this.ClaimNotesHistoryParameter.PageSize = this.perPageNotes;
            this.ClaimNotesHistoryParameter.PageNumber = this.currentPageNotes;
            await ClaimHistory.getAllNotesDetails(this.ClaimNotesHistoryParameter).then((response) => {
              this.notesList = response.data;
              this.notesList.forEach(element => {
                element.name = element.firstName && element.lastName ? element.firstName + " " + element.lastName : '';
                element.sysDate = element.sysDate ? Utils.formatterDateToString(element.sysDate) : null;
              })
            }).catch(error => {
              this.$emit('load', false);
              if (!error.response) {
                  // network error
                  console.log(error);
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                console.log(error);
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
                })
          },

          async getClaimARStatusHistory(item) {
            this.ClaimNotesHistoryParameter.SeqNo = item.seqNo;
            this.ClaimNotesHistoryParameter.PageSize = this.perPageStatus;
            this.ClaimNotesHistoryParameter.PageNumber = this.currentPageStatus;
            await ClaimHistory.getAllARStatusHistoryDetails(this.ClaimNotesHistoryParameter).then((response) => {
              this.arStatusList = response.data;
              this.arStatusList.forEach(element => {
                element.name = element.firstName && element.lastName ? element.firstName + " " + element.lastName : '';
                element.sysDate = element.sysDate ? Utils.formatterDateToString(element.sysDate) : null;
              })
            }).catch(error => {
              this.$emit('load', false);
              if (!error.response) {
                  // network error
                  console.log(error);
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                console.log(error);
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
                })
          },

          ChangeBulkStatus() {
            this.showModalClaimARStatus = true;
          },

          AddBulkNotes() {
            this.showClaimNoteModalEdit = true;
            this.ModelNote = '';
            this.IsReadOnly = false;
            this.ModalTitle = this.$t('Add Notes');
          },

        },

        created() {
          this.getStatus();
          this.getInsurances();
          this.getProviders();
          this.getARStatus();
        },

     async mounted(){
           this.OptionsRightMenu.ItemsList = [];
       let layoutStatus = this.$store.state.layoutStatus;
       switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }
      await this.getDateTime();
      this.getClaimList();
        }
}

</script>
